import { dataApps } from 'dls-icons-data'
import { createIcon } from '../common'

const IconApps = /*#__PURE__*/createIcon(dataApps)
export default IconApps
